import {useSearchParams} from "react-router-dom";
import SimulationList from "./SimulationList";
import SimulationDetail from "./SimulationDetail";

/**
 * /simulations shows the live list of MCP-driven pipeline sandboxes; /simulations?id=<id>
 * shows one of them live (tree + logs), matching this app's existing convention of query-param
 * "which record" navigation (see pipeline-builder's ?skeleton=, test-results' ?skeleton=)
 * rather than a nested path route.
 */
export default function Simulations() {
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id');
    return id ? <SimulationDetail/> : <SimulationList/>;
}
